import { render, staticRenderFns } from "./ArgTag.vue?vue&type=template&id=9af5ee12"
import script from "./ArgTag.vue?vue&type=script&lang=js"
export * from "./ArgTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports